export const AddressState = {
    // 送貨點
    DELIVERY_POINT: 1,
    // 取貨點
    PICKUP_POINT: 0,
    // 操作 - 新增
    ACTION_ADD: "add",
    // 操作 - 編輯
    ACTION_EDIT: "edit",
}
